import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Header from '../../components/Header/Header';
import LicensingModal from '../../components/LicensingModal/LicensingModal';
import Styles from './Home.module.css';

const Home = () => {
  const navigate = useNavigate();
  const iframeRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Focuses the iframe's internal window as soon as it loads
  const handleIframeLoad = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.focus();
    }
  };

  return (
    <div>
      <Header />
      <section className={Styles.hero}>
        <div className={Styles.heroContent}>
          <h1>
            The best way to master<br />
            any brass instrument!
          </h1>

          <div className={Styles.ctaSection}>
            <button
              className={Styles.teacherBtn}
              onClick={() => setIsModalOpen(true)}
            >
              I'm a Teacher
            </button>
            <button
              className={Styles.studentBtn}
              onClick={() => navigate('/signup')}
            >
              I'm a Student
            </button>
          </div>
        </div>
        <div className={Styles.heroImageContainer}>
          <iframe
            ref={iframeRef}
            src="/trumpet.html"
            title="Interactive Brassflows trumpet"
            className={Styles.heroFrame}
            loading="lazy"
            onLoad={handleIframeLoad}
            // Also focus it if the user hovers over the iframe container
            onMouseEnter={() => iframeRef.current?.contentWindow?.focus()}
          />
        </div>
      </section>
      <div className={Styles.trustBadge}>
        <p>
          Trusted by <strong>33,000+</strong> band kids across the world!
        </p>
      </div>
      <footer>
        <div className={Styles.footerLinks}>
          <a href="/privacy">Privacy Policy</a>
          <a href="/licensing">Licensing</a>
        </div>
        <p style={{ color: '#6b6b6b', fontSize: '14px' }}>
          © 2026 Brassflows. All rights reserved.
        </p>
      </footer>

      {isModalOpen && <LicensingModal onClose={() => setIsModalOpen(false)} />}
    </div>
  );
};

export default Home;